// eslint-disable-next-line import/no-mutable-exports
let DEFAULT_REGION = 'HK';
// eslint-disable-next-line import/no-mutable-exports
let DEFAULT_CITY_ID = 810001;
try {
  DEFAULT_REGION = process_env_idcDefaultRegion;
  const cityId = Number(process_env_idcDefaultCityid);
  if (Number.isSafeInteger(cityId) && cityId > 0) {
    DEFAULT_CITY_ID = cityId;
  }
} catch (e) {
  console.log(e);
}

export {
  DEFAULT_CITY_ID,
  DEFAULT_REGION,
};

// 代码内使用的标准环境名
export const ENV_MAP = {
  TEST: 'test',
  ST: 'st',
  STAGE: 'stage',
  PROD: 'prod',
};

export const AWPENVMAP = {
  local: ENV_MAP.TEST,
  dev: ENV_MAP.TEST,
  test: ENV_MAP.TEST,
  newtest: ENV_MAP.TEST,
  test01: ENV_MAP.TEST,
  test02: ENV_MAP.TEST,
  staging: ENV_MAP.ST,
  stage: ENV_MAP.ST,
  production: ENV_MAP.PROD,
};

export const NATIVE_ENV = {
  Test: ENV_MAP.TEST,
  Stage: ENV_MAP.STAGE,
  Prod: ENV_MAP.PROD,
};

export const isH5 = process_env_MACH_ENV === 'h5';

export const isIOS = isH5 ? false : Mach?.env?.isIOS;
export const isAndroid = isH5 ? false : Mach?.env?.isAndroid;

export const isWebAlert = location.search.includes('mpwebAlert=1') || window.self !== window.top;

export const DATE_STYLE_ENUM = {
  NONE: -1, //不展示日期
  YYYYMMDD: 1, //年月日（年是4位数，比如1999）
  YYMMDD: 2, //年月日（年是2位数，比如99）
  YYYYMMM: 3, //年月
  MMMDDEEE: 4, //月日星期
  MMMDD: 5, //月日
};

export const TIME_STYLE_ENUM = {
  NONE: -1, //不展示时间
  HHMMSS: 1, //时分秒
  HHMM: 2, //时分
};

export const TEST_ENV_HOST = 'fooddelivery.mykeeta.test.sankuai.com';

export const IS_EU_HOST = location.host.includes('-eu.') || location.host.includes('.keetapp.com');
export const IS_EU_APIHOST = IS_EU_HOST || process_env_publishIdc === 'EU';

// sso 登录相关
export const TEST_ENV_SSO_CLIENT_ID = '06cd1c6b8d';
export const PRODUCT_ENV_SSO_CLIENT_ID = '5487438b9a';

// c/b/d/m 端域名环境映射
export const HOSTENVMAP = {
  'fooddelivery.mykeeta.test.sankuai.com': ENV_MAP.TEST,
  'fooddelivery-eu.sailor.test.keetapp.com': ENV_MAP.TEST,
  'fooddelivery.mykeeta.st.sankuai.com': ENV_MAP.ST,
  'fooddelivery-eu.sailor.st.keetapp.com': ENV_MAP.ST,
  'fooddelivery.mykeeta.com': ENV_MAP.PROD,
  'fooddelivery-eu.mykeeta.com': ENV_MAP.PROD,

  'merchant.mykeeta.test.sankuai.com': ENV_MAP.TEST,
  'merchant-eu.sailor.test.keetapp.com': ENV_MAP.TEST,
  'merchant.mykeeta.st.sankuai.com': ENV_MAP.ST,
  'merchant-eu.sailor.st.keetapp.com': ENV_MAP.ST,
  'merchant.mykeeta.com': ENV_MAP.PROD,
  'merchant-eu.mykeeta.com': ENV_MAP.PROD,

  'developers.mykeeta.test.sankuai.com': ENV_MAP.TEST,
  'developers-eu.sailor.test.keetapp.com': ENV_MAP.TEST,
  'developers.mykeeta.st.sankuai.com': ENV_MAP.ST,
  'developers-eu.sailor.st.keetapp.com': ENV_MAP.ST,
  'developers.mykeeta.com': ENV_MAP.PROD,
  'developers-eu.mykeeta.com': ENV_MAP.PROD,

  'opcenter.mykeeta.test.sankuai.com': ENV_MAP.TEST,
  'opcenter-eu.sailor.test.keetapp.com': ENV_MAP.TEST,
  'opcenter.mykeeta.st.sankuai.com': ENV_MAP.ST,
  'opcenter-eu.sailor.st.keetapp.com': ENV_MAP.ST,
  'opcenter.mykeeta.com': ENV_MAP.PROD,
  'opcenter-eu.mykeeta.com': ENV_MAP.PROD,

  'courier.mykeeta.test.sankuai.com': ENV_MAP.TEST,
  'courier-eu.sailor.test.keetapp.com': ENV_MAP.TEST,
  'courier.mykeeta.st.sankuai.com': ENV_MAP.ST,
  'courier-eu.sailor.st.keetapp.com': ENV_MAP.ST,
  'courier.mykeeta.com': ENV_MAP.PROD,
  'courier-eu.mykeeta.com': ENV_MAP.PROD,

  'pay.mykeeta.test.sankuai.com': ENV_MAP.TEST,
  'pay.mykeeta.st.sankuai.com': ENV_MAP.ST,
  'pay.mykeeta.com': ENV_MAP.PROD,
};

export const cHosts = {
  test: 'fooddelivery.mykeeta.test.sankuai.com',
  st: 'fooddelivery.mykeeta.st.sankuai.com',
  prod: 'fooddelivery.mykeeta.com',
};

export const merchantHosts = {
  test: 'merchant.mykeeta.test.sankuai.com',
  st: 'merchant.mykeeta.st.sankuai.com',
  prod: IS_EU_HOST ? 'merchant-eu.mykeeta.com' : 'merchant.mykeeta.com',
};

export const mHosts = {
  test: 'opcenter.mykeeta.test.sankuai.com',
  st: 'opcenter.mykeeta.st.sankuai.com',
  prod: IS_EU_HOST ? 'opcenter-eu.mykeeta.com' : 'opcenter.mykeeta.com',
};

export const paymentHosts = {
  test: 'pay.mykeeta.test.sankuai.com',
  st: 'pay.mykeeta.st.sankuai.com',
  prod: 'pay.mykeeta.com',
};

export const merchantCashierRegionHosts = {
  hk: {
    test: 'pay.mykeeta.test.sankuai.com',
    st: 'pay.mykeeta.st.sankuai.com',
    prod: 'pay.mykeeta.com',
  },
  eu: {
    test: 'pay-eu.sailor.test.keetapp.com',
    st: 'pay-eu.sailor.st.keetapp.com',
    prod: 'pay-eu.mykeeta.com',
  },
};

const passportHosts = {
  test: IS_EU_HOST ? 'passport-eu.sailor.test.keetapp.com' : 'passport-i18n.fe.test.sankuai.com',
  st: IS_EU_HOST ? 'passport-eu.sailor.st.keetapp.com' : 'passport.mykeeta.st.sankuai.com', // 'passport-i18n.fe.st.sankuai.com',
  prod: IS_EU_HOST ? 'passport-eu.mykeeta.com' : 'passport.mykeeta.com',
};

// api的host需要根据实际业务region来映射机房
// 可直接替换为：process_env_map_passportApiHost
const passportApiTestHosts = {
  EU: ['passport-eu.wpt.test.sankuai.com', 'passport-eu.sailor.test.keetapp.com'],
  HK: ['passport-h.wpt.test.sankuai.com', 'passport-h.sailor.test.keetapp.com'],
};

const passportApiStHosts = {
  EU: ['passport.mykeeta.st.sankuai.com', 'passport-eu.sailor.st.keetapp.com', 'passport-eu.st.mykeeta.com'],
  HK: ['passport-hk.mykeeta.st.sankuai.com'], // 香港st不支持keetapp
};

const passportApiProdHosts = {
  EU: ['passport-eu.mykeeta.com', 'passport-eu.keeta-global.com'],
  HK: ['passport-hk.mykeeta.com', 'passport-hk.keeta-global.com'],
};

export const passportApiHosts = {
  test: passportApiTestHosts,
  st: passportApiStHosts,
  prod: passportApiProdHosts,
};

const openapiPassportApiTestHosts = {
  EU: ['passport-eu.wpt.test.sankuai.com', 'passport-service-eu.sailor.test.keetapp.com'],
  HK: ['passport-service-hk.wpt.test.sankuai.com'],
};

const openapiPassportApiStHosts = {
  EU: ['passport.mykeeta.st.sankuai.com', 'passport-service-eu.st.mykeeta.com'],
  HK: ['passport-service-hk.mykeeta.st.sankuai.com'],
};

const openapiPassportApiProdHosts = {
  EU: ['passport-service-eu.mykeeta.com'],
  HK: ['passport-service-hk.mykeeta.com'],
};

export const passportSwitchAuthApiHosts = {
  test: openapiPassportApiTestHosts,
  st: openapiPassportApiStHosts,
  prod: openapiPassportApiProdHosts,
};

export const csHosts = {
  test: 'cs.mykeeta.test.sankuai.com',
  st: 'cs.mykeeta.st.sankuai.com',
  prod: 'cs.mykeeta.com',
};

// client: cs/payment/passport/c/b/m
export const clientEnvHostConfig = {
  cs: csHosts,
  payment: paymentHosts,
  passport: paymentHosts,
  c: cHosts,
  b: merchantHosts,
  m: mHosts,
};

// https://km.sankuai.com/page/1636423009
export const passportService = 'consumer';

export const passportConfig = {
  test: {
    host: passportHosts.test,
    tokenId: '9BbjT_ljW_oO9iIW0PNQNA',
    joinkey: '1101470_49115925',
  },
  st: {
    host: passportHosts.st,
    tokenId: '9BbjT_ljW_oO9iIW0PNQNA',
    joinkey: '1101470_49115925',
  },
  prod: {
    host: passportHosts.prod,
    tokenId: '9BbjT_ljW_oO9iIW0PNQNA',
    joinkey: '1101470_49115925',
  },
};

export const BUCKET_NAME_TEST = 'sailorfempcpublic';
export const BUCKET_NAME_PROD = 'sailorfempcpublic';
export const VENUS_CLIENT_TEST = '82hkdn425qs2bxqt000000000071cbab';
export const VENUS_CLIENT_PROD = 'pmcxkzm42l7nb2xs00000000002d62c0';
export const VENUS_CLIENT_SECRET_TEST = 'q5XAuMG25KMiUIavTyKPzkjwGG5EnwIdJLrdjulPB9Zx1PUcmB1frFEK9/qtWEXAbYWo5Jverwnz3TBwLAgvSH537zKl438Q7dr5rFt3XChwYw2uEZRadtTnI2n2RFMh3uVvu9NTdZiR5Z7Z0xMzksJzSxvy7EY4OeaB+7h/4js=';
export const VENUS_CLIENT_SECRET_PROD = 'eyaDx/zAsnRx8es5TZQgCc6gldaVzjdHBEy1YzjISitlueS5zedecooZJfpDRnrAvnqdnZTZzYQ0uU2FcaFvffefe1/tPIPO7FOeFT8unUxvr0QcZYEO7sOTBmQObEAg2yekrWzo3uucV1/wzaOQTjFPZ1v69rAU0nSAL/EVU2w=';

export const VENUS_ENV_TEST = 'userCenterTest';
export const VENUS_ENV_PROD = 'userCenter';

export const INPUT_CHANGE_DEBOUNCE_WAITING = 200;

export const H5_APPNAME = process_env_appName;

/**
 * 当前定位快照使用的统一 Storage key。
 *
 * 新数据持久化到 localStorage；sessionStorage 中的同名 key 仅用于兼容读取历史缓存，
 * 避免升级后丢失用户最近一次定位信息。
 */
export const LOCATION_INFO_STORAGE_KEY = 'm2h_location_info';

export const sessionKeys = {
  // 历史 sessionStorage 定位缓存，仅作为读取兜底，不再作为新数据的写入目标。
  LOCATION_INFO: LOCATION_INFO_STORAGE_KEY,
  ADDRESS_LAST_SELSECTED: 'm2h_SLUserAddress_last_selected', // 迁移到localstorage
  REGION_CONFIGS: 'm2h_region_configs', // 迁移到localstorage
  HOME_SELSECTED_ADDRESS: 'm2h_SLUserAddress_homeSelected',
  SESSION_MACH_DATA: 'm2h_mach_data',
  SESSION_MACH_ENV: 'm2h_mach_env',
  SESSION_MACH_SCHEMEPARAMS: 'm2h_mach_schemeParams',
};

export const localKeys = {
  // 当前定位快照的持久化缓存，写入时会整体覆盖原值。
  LOCATION_INFO: LOCATION_INFO_STORAGE_KEY,
  ADDRESS_LAST_SELSECTED: 'm2h_SLUserAddress_last_selected', // 迁移到localstorage
  REGION_CONFIGS: 'm2h_region_configs', // 迁移到localstorage
  LOCAL_MACH_SCHEME_DATA: 'm2h_l_scheme_data',
  LOCAL_MACH_STRATEGY: 'm2h_l_strategy',
  LOCAL_MACH_STRATEGY_COM: 'm2h_l_strategy_com',
};

// 应用平台platform
export const APP_PLATFORM = {
  unknow: -1,
  pc: 1,
  h5: 3, // 手机浏览器打开的h5页面
  android: 4,
  ios: 5,
};

export const EMPTY_FUNC = () => {};
